/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */

import React from 'react';
import Figure from '../Figure';
import FigCaption from '../FigCaption';
import FigContainer from '../FigContainer';
import CategoryHeader from '../CategoryHeader';

/* eslint-disable prettier/prettier */
import IconCheckBox from '../../../../../../Icon/IconCheckBox';
import IconCheckBoxOutlineBlank from '../../../../../../Icon/IconCheckBoxOutlineBlank';
import IconIndeterminateCheckBox from '../../../../../../Icon/IconIndeterminateCheckBox';
import IconRadioButtonChecked from '../../../../../../Icon/IconRadioButtonChecked';
import IconRadioButtonUnchecked from '../../../../../../Icon/IconRadioButtonUnchecked';
import IconStar from '../../../../../../Icon/IconStar';
import IconStarBorder from '../../../../../../Icon/IconStarBorder';
import IconStarHalf from '../../../../../../Icon/IconStarHalf';

export default function ToggleIcons() {
  return (
    <div>
      <CategoryHeader>toggle</CategoryHeader>
      <FigContainer>
        <Figure tabIndex={0}>
          <IconCheckBox size="32"/>
          <FigCaption>
            IconCheckBox
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCheckBoxOutlineBlank size="32"/>
          <FigCaption>
            IconCheckBoxOutlineBlank
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconIndeterminateCheckBox size="32"/>
          <FigCaption>
            IconIndeterminateCheckBox
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRadioButtonChecked size="32"/>
          <FigCaption>
            IconRadioButtonChecked
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRadioButtonUnchecked size="32"/>
          <FigCaption>
            IconRadioButtonUnchecked
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconStar size="32"/>
          <FigCaption>
            IconStar
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconStarBorder size="32"/>
          <FigCaption>
            IconStarBorder
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconStarHalf size="32"/>
          <FigCaption>
            IconStarHalf
          </FigCaption>
        </Figure>
      </FigContainer>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/website/app/demos/Icon/components/categories/ToggleIcons.js